"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ela(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M8.25 16.5892L12 14.4742V18.7005L8.25 16.5892ZM8.25 9.83924L12 7.72424V11.9505L8.25 9.83924Z", fill: color, fillOpacity: 0.4 }),
        React.createElement("path", { d: "M19.5 14.4225L15.75 16.587V12.3225L19.5 14.4225ZM19.5 7.67249L15.75 9.83699V5.57249L19.5 7.67249Z", fill: color, fillOpacity: 0.7 }),
        React.createElement("path", { d: "M8.25 16.587V12.3248L12 14.4773L8.25 16.587ZM8.25 9.837V5.57475L12 7.72725L8.25 9.837Z", fill: color, fillOpacity: 0.8 }),
        React.createElement("path", { d: "M15.75 16.587L12 14.478L15.75 12.3225V16.587ZM15.75 9.83699L12 7.72799L15.75 5.57249V9.83699Z", fill: color }),
        React.createElement("path", { d: "M15.75 16.587L12 18.7005V14.478L15.75 16.587ZM15.75 9.837L12 11.9505V7.728L15.75 9.837Z", fill: color, fillOpacity: 0.6 }),
        React.createElement("path", { d: "M8.25 12.3255V16.5878L4.5 14.424L8.25 12.3255ZM8.25 5.5755V9.83775L4.5 7.674L8.25 5.5755Z", fill: color, fillOpacity: 0.5 }),
        React.createElement("path", { d: "M8.25 16.4528L12 14.3378V18.564L8.25 16.4528ZM8.25 9.70275L12 7.58775V11.814L8.25 9.70275Z", fill: color, fillOpacity: 0.4 }),
        React.createElement("path", { d: "M19.5 14.286L15.75 16.4505V12.186L19.5 14.286ZM19.5 7.536L15.75 9.7005V5.436L19.5 7.536Z", fill: color, fillOpacity: 0.7 }),
        React.createElement("path", { d: "M8.25 16.4505V12.1883L12 14.3408L8.25 16.4505ZM8.25 9.70051V5.43826L12 7.59076L8.25 9.70051Z", fill: color }),
        React.createElement("path", { d: "M15.75 16.4505L12 14.3415L15.75 12.186V16.4505ZM15.75 9.7005L12 7.5915L15.75 5.436V9.7005Z", fill: color }),
        React.createElement("path", { d: "M15.75 16.4505L12 18.564V14.3415L15.75 16.4505ZM15.75 9.70051L12 11.814V7.59151L15.75 9.70051Z", fill: color, fillOpacity: 0.6 }),
        React.createElement("path", { d: "M8.25 12.189V16.4513L4.5 14.2875L8.25 12.189ZM8.25 5.43901V9.70126L4.5 7.53751L8.25 5.43901Z", fill: color, fillOpacity: 0.5 }));
}
exports["default"] = ela;
//# sourceMappingURL=ela.js.map